import { GetExternoDetalle } from "../../reducers/externoDetalle";

export interface ExternoDetalleStore extends GetExternoDetalle {}

export const externoDetalleStore: (state) => ExternoDetalleStore = state => {
  const { externoDetalle } = state;
  return {
    externoDetalle: externoDetalle.externoDetalle,
    gettingExternoDetalle: externoDetalle.gettingExternoDetalle,
    gettingExternoDetalleError: externoDetalle.gettingExternoDetalleError
  };
};
